import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const machines = [{
  id: 1,
  topTitle: '2012 Mikron HEM 1000 Machining Center',
  category: 'Used Machining Center',
  filterCategory: 'cnc',
  title: '2012 Mikron HEM 1000 - 3-Axis Machining Center',
  priceText: 'Priced To Sell!',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2012%20HEM%201000/machine%20f%20w%20logo.jpg',
  detailUrl: 'm7/HEM%201000%20-%203-Axis%20Machining%20Center--2012-mikron-hem-1000-machining-center.html',
  specs: null
}, {
  id: 2,
  topTitle: '2014 Mikron HEM 1000 Machining Center w/ 4th axis rotary',
  category: 'Used Machining Center',
  filterCategory: 'cnc',
  title: '2014 Mikron HEM 1000 - 3-Axis Machining Center',
  priceText: 'Priced To Sell!',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2014%20HEM%201000/Machine%201%20w%20logo.jpg',
  detailUrl: 'm7/HEM%201000%20-%203/4%20Axis%20Machining%20Center--2014-mikron-hem-1000-machining-center-w-4th-axis-rotary.html',
  specs: null
}, {
  id: 3,
  topTitle: '2011 Mikron HSM 500 High Speed Machining Center',
  category: 'Used High Speed Machining Center',
  filterCategory: 'cnc',
  title: '2011 Mikron HSM 500 - 3-Axis High Speed Machining Center',
  priceText: 'Priced To ...',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2011%20HSM%20500/Machine%20F%20w%20logo.jpg',
  detailUrl: 'm7/HSM%20500%20-%203-Axis%20Machining%20Center--2011-mikron-hsm-500-high-speed-machining-center.html',
  specs: null
}, {
  id: 4,
  topTitle: '2016 AgieCharmilles CUT E 350',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'AgieCharmilles CUT E 350',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/Used%20AgieCharmilles%20CUT%20E%20350%20Wire%20EDM%20-%20Peak.png',
  detailUrl: 'm7/Used%20CUT%20E%20350--2016-agiecharmilles-cut-e-350.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '13.78" x 9.8" x 9.8"'
  }]
}, {
  id: 5,
  topTitle: '2019 Makino U6 Heat',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'Makino U6 Heat',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2019%20Makino%20U6%20Heat/Makino%20U6Front%20w%20logo.jpg',
  detailUrl: 'm7/U6%20Heat--2019-makino-u6-heat.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '25.6" x 17.72" x 16.53"'
  }]
}, {
  id: 6,
  topTitle: '2004 Charmilles HD 20',
  category: 'Used Drilling EDM',
  filterCategory: 'drilling-edm',
  title: 'Charmilles HD 20',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2004%20Charmilles%20HD20/HD%2020%20front.jpg',
  detailUrl: 'm7/Used%20Charmilles%20HD20--2004-charmilles-hd-20.html',
  specs: [{
    label: 'Type:',
    value: 'DRILL EDM'
  }, {
    label: 'Travels X Y:',
    value: '13.8" x 9...'
  }]
}, {
  id: 7,
  topTitle: '2004 Charmilles Robofill 240',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'Charmilles Robofil 240',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2004%20Charmilles%20240/2004%20240%20Front%20w%20logo2.jpg',
  detailUrl: 'm7/Robofil%20240--2004-charmilles-robofill-240.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '13.77" x 8.66" x 8.66"'
  }]
}, {
  id: 8,
  topTitle: '2014 AgieCharmilles CUT 20P',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'AgieCharmilles CUT 20P',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2014%20CUT%2020%20P/Used%20AgieCharmilles%20CUT%2020%20Wire%20EDM%20Front%20-%20Peak%20Machine%20Sales.png',
  detailUrl: 'm7/2014%20AgieCharmilles%20CUT%2020P--2014-agiecharmilles-cut-20p.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '13.78" x 9.8" x 9.8"'
  }]
}, {
  id: 9,
  topTitle: '2015 Makino EDNC 85S',
  category: 'Used Sinker EDM',
  filterCategory: 'sinker-edm',
  title: 'Makino EDNC 85S',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2015%20Makino%20EDNC%2085S/Makino%20EDNC%2085.jpg',
  detailUrl: 'm7/2356984--2015-makino-ednc-85s.html',
  specs: [{
    label: 'Type:',
    value: 'SINKER EDM'
  }, {
    label: 'Travels:',
    value: '31.5" x 19.7" x 15.7...'
  }]
}, {
  id: 10,
  topTitle: '2019 AgieCharmilles FORM E 600',
  category: 'Used Sinker EDM',
  filterCategory: 'sinker-edm',
  title: 'AgieCharmilles FORM E 600',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2019%20Form%20E600/Form%20E600%20F%20w%20logo.jpg',
  detailUrl: 'm7/2356982--2019-agiecharmilles-form-e-600.html',
  specs: [{
    label: 'Type:',
    value: 'SINKER EDM'
  }, {
    label: 'Travels:',
    value: '23.63" x ...'
  }]
}, {
  id: 11,
  topTitle: '2018 AgieCharmilles FORM E 350',
  category: 'Used Sinker EDM',
  filterCategory: 'sinker-edm',
  title: 'AgieCharmilles FORM E 350',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2018%20Form%20E350/E350front%20w%20logo.jpg',
  detailUrl: 'm7/2356981--2018-agiecharmilles-form-e-350.html',
  specs: [{
    label: 'Type:',
    value: 'SINKER EDM'
  }, {
    label: 'Travels:',
    value: '13.8" x 9...'
  }]
}, {
  id: 12,
  topTitle: '2013 AgieCharmilles CUT 300',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'AgieCharmilles CUT 300',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/2013%20CUT%20300/IMG_1584.jpg',
  detailUrl: 'm7/AgieCharmilles%20CUT%20300%20-%20Used--2013-agiecharmilles-cut-300.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '21.65 x13.77 x 15.75'
  }]
}, {
  id: 13,
  topTitle: '2014 AgieCharmilles CUT 30 P',
  category: 'Used Wire EDM',
  filterCategory: 'wire-edm',
  title: 'AgieCharmilles CUT 30P',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Used%20machines/Used%20AgieCharmilles%20CUT%2030%20P%20Wire%20EDM%20-%20Peak%20stock%20photo.png',
  detailUrl: 'm7/2014%20AgieCharmilles%20CUT%2030%20P--2014-agiecharmilles-cut-30-p.html',
  specs: [{
    label: 'Type:',
    value: 'WIRE EDM'
  }, {
    label: 'Travels:',
    value: '23.6" x 15.70" x 13.75"'
  }]
}, {
  id: 14,
  topTitle: 'Advantage Chiller - 2000 230v',
  category: 'Used Machine Tool Chiller',
  filterCategory: 'chillers',
  title: '230v Advantage Chiller',
  description: 'To be used with NON submerged cutting Wire EDM ...',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Chillers%20%26%20Transformers/2000%20230V%20Advantage%20Chiller%20-%20No%20Reservoir.jpg400x400.jpg',
  detailUrl: 'm7/Advantage%20Chiller%20-%20Used%201--advantage-chiller-2000-230v.html',
  specs: null
}, {
  id: 15,
  topTitle: 'Advantage Chiller - 2011 460v',
  category: 'Used Machine Tool Chiller',
  filterCategory: 'chillers',
  title: '460v Advantage Chiller with No Reservoir',
  description: 'To be used with NON-submerged ...',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Chillers%20%26%20Transformers/2011%20Advantage%20Chiller%20460v.jpg',
  detailUrl: 'm7/Advantage%20Chiller%20-%20Used%202--advantage-chiller-2011-460v.html',
  specs: null
}, {
  id: 16,
  topTitle: 'Filtrine Chiller - 230v',
  category: 'Used Machine Tool Chiller',
  filterCategory: 'chillers',
  title: '230v Single Phase Filtrine Chiller with Reservoir',
  description: 'Has a reservoir, ...',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Chillers%20%26%20Transformers/IMG_9867.jpg',
  detailUrl: 'm7/Used%20Machine%20Tool%20Chiller--filtrine-chiller-230v.html',
  specs: null
}, {
  id: 17,
  topTitle: '12 kVA transformer',
  category: 'Used 12 kVA Transformer',
  filterCategory: 'chillers',
  title: '3 Phase 50/60 Hz',
  description: 'Primary Voltage: 190-600\nSecondary ...',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Chillers%20%26%20Transformers/IMG_9871.jpg',
  detailUrl: 'm7/Used%20Transformer--12-kva-transformer.html',
  specs: null
}];
export function InventoryListingSection() {
  return <div className="flex-1" data-id="element-4071">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8" data-id="element-4072">
        {machines.map(machine => <a key={machine.id} href={machine.detailUrl} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full no-underline" data-id="element-4073">
            {/* Image Container */}
            <div className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 relative" data-id="element-4074">
              <img src={machine.image} alt={machine.topTitle} className="block max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-4075" />
              {machine.priceText && <div className="absolute top-4 right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-4076">
                  {machine.priceText}
                </div>}
            </div>

            {/* Content Container */}
            <div className="p-6 flex flex-col flex-grow" data-id="element-4077">
              <div className="mb-3" data-id="element-4078">
                <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-orange/10 text-orange" data-id="element-4079">
                  {machine.category}
                </span>
              </div>

              <div className="text-xs text-gray-500 font-medium mb-1 uppercase tracking-wider" data-id="element-4080">
                {machine.topTitle}
              </div>

              <h3 className="text-lg font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-4081">
                {machine.title}
              </h3>

              {/* Specs or Description */}
              <div className="mb-6 flex-grow" data-id="element-4082">
                {machine.description && <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed" data-id="element-4083">
                    {machine.description}
                  </p>}

                {machine.specs && <div className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden" data-id="element-4084">
                    <table className="w-full text-sm text-left" data-id="element-4085">
                      <tbody data-id="element-4086">
                        {machine.specs.map((spec, idx) => <tr key={idx} className="border-b border-gray-100 last:border-0" data-id="element-4087">
                            <th className="py-2 px-3 font-semibold text-gray-700 w-1/3 bg-gray-100/50" data-id="element-4088">
                              {spec.label}
                            </th>
                            <td className="py-2 px-3 text-gray-600" data-id="element-4089">
                              {spec.value}
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>}
              </div>

              {/* Bottom Action */}
              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-4090">
                <span className="inline-flex items-center text-orange font-bold text-sm group-hover:text-navy transition-colors" data-id="element-4091">
                  View Details
                  <ArrowRightIcon className="w-4 h-4 ml-1.5 group-hover:translate-x-1 transition-transform" data-id="element-4092" />
                </span>
              </div>
            </div>
          </a>)}
      </div>
    </div>;
}